/**
 * Qui règle les RÉCOMPENSES (BizCoins) — réglages de l'entreprise, catalogue de cadeaux, mode de
 * récompense d'un challenge ou d'un parcours. Liste UNIQUE, lue par le serveur
 * (`src/api/biz-coins.ts`) ET par l'écran (`ChallengePage`). Pure : importable côté client.
 *
 * CSL retiré (décision de Valérie du 30/09/2026) : il changeait le mode de récompense de tout
 * challenge ou parcours de tout compte. Fermé tant que ses droits ne sont pas arbitrés.
 */
export const REWARDS_SETTINGS_PROFILES = ["ORG", "COO", "ADM"] as const;

export function canManageRewards(profileType?: string | null): boolean {
  return !!profileType && (REWARDS_SETTINGS_PROFILES as readonly string[]).includes(profileType);
}

/** Internes Kestio qui changent le mode de récompense d'un challenge / parcours d'un autre compte. */
export const REWARDS_CROSS_ACCOUNT_PROFILES = ["ADM", "COO"] as const;
